import styled from "styled-components/native";
import { View } from "react-native";

export const StyledView = styled(View)`
  position: absolute;
  max-width: fill-available;
`;
